<template>
  <div class="majorities-content">
    <div v-if="$route.path.includes('edit') || $route.path.includes('create')" class="sub-header">
      <b-container fluid>
        <appCatalogsNav
          v-if="$route.path.includes('create')"
          :title="titleCreate"
          :breadcrumb-last="breadcrumbLastCreate"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
        <appCatalogsNav
          v-else-if="$route.path.includes('edit')"
          :title="titleEdit"
          :breadcrumb-last="breadcrumbLastEdit"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
      </b-container>
    </div>
    <b-container fluid>
      <div v-if="!$route.path.includes('edit') && !$route.path.includes('create')">
        <b-container>
          <b-button class="button btn-blue fw-600 my-4" :to="{ name: 'create-majority' }">
            <font-awesome-icon class="agv-button-icon" icon="plus" />
            <span>{{ $t("catalogs.majorities_create") }}</span>
          </b-button>
        </b-container>

        <b-container>
          <appMajoritiesTable></appMajoritiesTable>
        </b-container>
      </div>

      <router-view />
    </b-container>
  </div>
</template>

<script>
import appCatalogsNav from "@/components/snippets/CatalogsNav";

import MajorityMW from "@/middlewares/Majority";
import MajorityORM from "@/store/orm-axios/models/Majority";

import mercureMixin from "@/mixins/mercure-live-changes/majorities";

export default {
  components: {
    appCatalogsNav,
    appMajoritiesTable: () => import("@/components/catalogs/majorities/MajoritiesTable"),
  },
  mixins: [mercureMixin],
  data() {
    return {
      titleCreate: this.$t("catalogs.majorities_create"),
      breadcrumbLastCreate: this.$t("general.create"),
      titleEdit: this.$t("catalogs.majorities_edit"),
      breadcrumbLastEdit: this.$t("general.edit"),
      breadcrumbRouteText: this.$t("catalogs.majorities"),
      breadcrumbRouteName: "majorities",
      MajorityMW: MajorityMW,
      MajorityORM: MajorityORM,
    };
  },
};
</script>
